import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import type { IModuleGuideItem } from '@components/module-guide/module-guide.component';

@Component({
	selector: 'app-module-guide',
	templateUrl: './module-guide.component.html',
	styleUrls: ['./module-guide.component.scss'],
})
export class ModuleGuideModalComponent {

	public HeaderTitle: string = "";
	public Description: string = "";
	public Items: IModuleGuideItem[] = [];

	constructor(
		private ModalController: ModalController,
		private NavParams: NavParams
	) {

		this.HeaderTitle = this.NavParams.get('headerTitle') || this.HeaderTitle;
		this.Description = this.NavParams.get('description') || this.Description;
		this.Items = this.NavParams.get('items') || this.Items;
	}

	public Close() {

		this.ModalController.dismiss();
	}
}
